import { render, staticRenderFns } from "./ElectionsVoteListWithCandidates.vue?vue&type=template&id=4758f0b7&scoped=true"
import script from "./ElectionsVoteListWithCandidates.vue?vue&type=script&lang=js"
export * from "./ElectionsVoteListWithCandidates.vue?vue&type=script&lang=js"
import style0 from "./ElectionsVoteListWithCandidates.vue?vue&type=style&index=0&id=4758f0b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758f0b7",
  null
  
)

export default component.exports